import { ClientResponseError } from "pocketbase";
import i18n from "@/i18n";
import type { PlanFeature } from "./plans";

const FEATURES: PlanFeature[] = [
  "templates",
  "invoices",
  "quotes",
  "customers",
  "paymentMethods",
  "charts",
  "workspaces",
];

/**
 * The feature a request was refused for because of the plan (`data.plan.code` = "plan_<feature>",
 * see planError() in server/pb_hooks/lib/plans.js), or null for any other error.
 */
export function planFeatureOf(error: unknown): PlanFeature | null {
  if (!(error instanceof ClientResponseError)) return null;
  const code = (error.response?.data as { plan?: { code?: string } } | undefined)?.plan?.code;
  const feature = code?.startsWith("plan_") ? code.slice(5) : "";
  return FEATURES.find((candidate) => candidate === feature) ?? null;
}

/** The message to toast for a failed request; null for plan refusals (the dialog explains them). */
export function errorToast(error: unknown): string | null {
  if (planFeatureOf(error)) return null;
  // A server refusal we have wording for (serverErrors.*) shows in the UI language.
  if (error instanceof ClientResponseError) {
    const data = (error.response?.data ?? {}) as Record<string, { code?: string } | undefined>;
    const key = Object.values(data)
      .map((field) => `serverErrors.${field?.code ?? ""}`)
      .find((candidate) => i18n.exists(candidate));
    if (key) return i18n.t(key as never);
  }
  return error instanceof Error ? error.message : String(error);
}
